import { render } from "./ParentLayout.vue?vue&type=template&id=9c055a70&ts=true"
import script from "./ParentLayout.vue?vue&type=script&lang=ts"
export * from "./ParentLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__